import { Layout1Route } from "./layout1-route";
import { ExtraPages } from "./extra-pages-route";


export const LayoutsRoute = [...Layout1Route, ...ExtraPages];
